import r from"../internals/export.js";import t from"../internals/string-trim.js";import i from"../internals/string-trim-forced.js";var m=r,o=t.trim,e=i;m({target:"String",proto:!0,forced:e("trim")},{trim:function(){return o(this)}});
